import { ReactElement } from 'react';
import { Controller, Control, ControllerProps, useFormContext } from 'react-hook-form';
import MuiPhoneNumber, { MuiPhoneNumberProps } from 'material-ui-phone-number';

const PHONE_REGEX = /^\+[()0-9+ -]+$/;

const fixPhoneValue = (value: Optional<string>) => {
  if (!PHONE_REGEX.test(value || '')) return null; // null is important!
  return value;
};

type MuiPhoneNumberPropsWithoutOnChange = Omit<MuiPhoneNumberProps, 'onChange'>;

type Props = MuiPhoneNumberPropsWithoutOnChange &
  Omit<ControllerProps, 'control' | 'render'> & {
    control?: Control<any>; // eslint-disable-line
  };

export const ControlledPhoneField = ({ control: controlProp, ...rest }: Props): ReactElement => {
  const formContext = useFormContext();
  const control = controlProp || formContext?.control;

  if (!control) {
    throw new Error('ControlledPhoneField must be used within a FormProvider or receive a control prop');
  }

  return (
    <Controller
      {...rest}
      control={control}
      render={({ field, fieldState }) => (
        <MuiPhoneNumber
          {...rest}
          {...field}
          value={fixPhoneValue(field.value)}
          defaultCountry="us"
          error={Boolean(fieldState.error)}
          helperText={fieldState.error?.message}
        />
      )}
    />
  );
};

export default ControlledPhoneField;
